import {PropertyAnnotation, Fragmenter} from 'substance'

class StrongNode extends PropertyAnnotation {
}

StrongNode.type = 'strong'

// a hint that makes in case of overlapping annotations that this
// annotation gets fragmented more often
StrongNode.fragmentation = Fragmenter.ANY

export {StrongNode}
